import type { WatchList } from "@/App/Equities/shared/services/TradingGateway"

import { mockInstruments } from "./equityInstrumentServiceData"

export const mockWatchLists: WatchList[] = [
  {
    id: "1",
    accountId: "123456789",
    createdAt: "",
    updatedAt: "",
    name: "Test Watch List One",
    assets: mockInstruments.map((instrument) => ({
      ...instrument,
      tradable: true,
      status: "ACTIVE",
      marketCapitalization: instrument.marketCapitalization.toString(),
    })),
  },
  {
    id: "2",
    accountId: "987654321",
    createdAt: "",
    updatedAt: "",
    name: "Test Watch List Two",
    assets: mockInstruments.slice(-1).map((instrument) => ({
      ...instrument,
      tradable: true,
      status: "ACTIVE",
      marketCapitalization: instrument.marketCapitalization.toString(),
    })),
  },
]
